<template>
  <v-container>
    <v-row class="justify-center">
      <v-col cols="12" md="8" lg="8">
        <v-card class="pa-4">
          <v-card-title class="text-h5 font-weight-bold">New Trade Order</v-card-title>
          <v-card-text>
            <v-row class="pa-0 ma-0">
              <v-col cols="12" class="pa-0 ma-0">
                <v-textarea v-model="tradeInput" label="Enter Trade Details" hint="e.g., 24800 call buy 300 qty sept end"
                  rows="6" outlined clearable />
              </v-col>
            </v-row>
  
            <v-row class="pa-0 ma-0">
              <v-col cols="5" class="pa-0 ma-0">
                <v-btn color="secondary" :loading="loading" size="small" block @click="getTradeOrderDetails">
                  Get Trade Order Details
                </v-btn>
              </v-col>
            </v-row>
  
            <v-divider class="my-4"></v-divider>
  
            <v-row class="pa-0 ma-0">
              <v-col cols="12" class="pa-0 ma-0">
                <v-textarea v-model="formattedTradeOrderDetails" label="Trade Order Details" rows="6" outlined />
              </v-col>
            </v-row>
  
            <v-row class="pa-0 ma-0">
              <v-col cols="5" class="pa-0 ma-0">
                <v-btn color="primary" :disabled="!tradeOrderDetails" size="small" block @click="placeOrder">
                  Place Order
                </v-btn>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  
    <!-- Orders table -->
    <v-row v-if="orderDisplays.length" class="mt-6 justify-center">
      <v-col cols="12" md="8" lg="8">
        <v-card-title class="text-h6 font-weight-bold">Placed Orders</v-card-title>
        <v-data-table :headers="headers" :items="orderDisplays" class="elevation-1">
          <template #[`item.exchange_order_id`]="{ item }">
            {{ item.exchange_order_id }}
          </template>
  
          <template #[`item.stock_code`]="{ item }">
            {{ item.stock_code }}
          </template>
  
          <template #[`item.action`]="{ item }">
            <v-chip :color="item.action === 'BUY' ? 'green' : 'red'" size="small">
              {{ item.action }}
            </v-chip>
          </template>
  
          <template #[`item.status`]="{ item }">
            <v-chip :color="item.status === 'COMPLETE' ? 'green' : 'orange'" size="small">
              {{ item.status }}
            </v-chip>
          </template>
        </v-data-table>
  
      </v-col>
    </v-row>
  
    <v-snackbar v-model="snackbar" :timeout="3000" :color="snackbarColor" location="top right">
      {{ snackbarMessage }}
    </v-snackbar>
  </v-container>
</template>

<script>
import { mapState, mapActions } from "vuex";

export default {
  data() {
    return {
      tradeInput: "",
      loading: false,
      snackbar: false,
      snackbarMessage: "",
      snackbarColor: "success",
      tradeOrderDetails: "",
      formattedTradeOrderDetails: null,
      orderDisplays: [], // store placeOrder API response
      headers: [
        { text: "Order ID", value: "exchange_order_id" },
        { text: "Stock Code", value: "stock_code" },
        { text: "Action", value: "action" },
        { text: "Quantity", value: "quantity" },
        { text: "Price", value: "average_price" },
        { text: "Status", value: "status" },
      ],
    };
  },
  computed: {
    ...mapState("indicators", ["tradeOrderDetails"]),
    ...mapState("trades", ["tradePositionDataList"]),
  },
  methods: {
    ...mapActions("indicators", ["convertToOrder"]),
    ...mapActions("orders", ["placeOrderList"]),

    async getTradeOrderDetails() {
      if (!this.tradeInput) {
        this.showSnackbar("Please enter trade details.", "error");
        return;
      }
      this.loading = true;
      try {
        const cleanedInput = this.tradeInput.replace(/\n/g, ",");
        const apiResponse = await this.convertToOrder({
          tradeInputList: cleanedInput,
        });

       if (apiResponse && Array.isArray(apiResponse.tradePositionDataList)) {
          this.tradeOrderDetails = apiResponse.tradePositionDataList;
          this.formattedTradeOrderDetails = this.tradeOrderDetails
            .map((item) => Object.values(item).join(" "))
            .join("\n");
        } else {
          this.tradeOrderDetails = null;
          this.formattedTradeOrderDetails =
            "No trade details found or invalid response format.";
        }

        this.showSnackbar("Trade order details fetched successfully!", "success");
      } catch (error) {
        console.error("❌ getTradeOrderDetails error:", error);
        this.showSnackbar("Failed to fetch trade order details.", "error");
      } finally {
        this.loading = false;
      }
    },

    async placeOrder() {
      console.log("placeOrder", this.formattedTradeOrderDetails);
      if (!this.formattedTradeOrderDetails || this.formattedTradeOrderDetails.length === 0) {
        this.showSnackbar("No trade order details to place.", "error");
        return;
      }
      this.loading = true;
      try {
        // convert formattedTradeOrderDetails string into array of strings
        const tradeOrderStrings = this.formattedTradeOrderDetails.split("\n").filter(l => l.trim());

        console.log("tradeOrderStrings", tradeOrderStrings);

        const resp = await this.placeOrderList({
          tradeOrderDetails: tradeOrderStrings,
        });
        console.log("✅ placeOrder resp:", resp);

        this.orderDisplays = resp && Array.isArray(resp.orderDisplayList)
          ? resp.orderDisplayList
          : [];

        this.showSnackbar("Order placed successfully!", "success");
        this.tradeInput = "";
      } catch (error) {
        console.error("❌ placeOrder error:", error);
        this.showSnackbar("Failed to place order.", "error");
      } finally {
        this.loading = false;
      }
    },
    showSnackbar(message, color) {
      this.snackbarMessage = message;
      this.snackbarColor = color;
      this.snackbar = true;
    },
  },
};
</script>

